import React from "react";
import { Box, Button, Skeleton } from "@mui/material";
import freeVoteIcon from "../../../assets/customerAssets/icons/crownVoteIcon.svg";
import freeVoteIconV from "../../../assets/customerAssets/icons/crownVoteIconRed.svg";

/** Crown vote control — matches CompetitionVoteButton styling for consistency. */
export default function FinalNightVoteButton({
  loading = false,
  disabled = false,
  voted = false,
  onClick,
  compact = false,
}) {
  return (
    <Box
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        px: compact ? 1 : 1.25,
        py: compact ? 0.4 : 0.55,
        borderRadius: 999,
        bgcolor: "rgba(239,54,78,0.12)",
        border: "1px solid rgba(239,54,78,0.35)",
        backdropFilter: "blur(6px)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        cursor: disabled ? "not-allowed" : "pointer",
        "&:hover": disabled
          ? undefined
          : {
              transform: "scale(1.04)",
              boxShadow: "0 0 18px rgba(239,54,78,0.35)",
            },
        opacity: disabled ? 0.55 : 1,
      }}
    >
      <Button
        disabled={loading || disabled}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick?.(e);
        }}
        sx={{
          minWidth: 0,
          p: 0,
          "& img": { width: compact ? 22 : 26, height: compact ? 22 : 26 },
        }}
      >
        {loading ? (
          <Skeleton animation="wave" variant="circular" width={26} height={26} />
        ) : (
          <img
            src={voted ? freeVoteIconV : freeVoteIcon}
            alt="Vote"
            className="iconImg"
          />
        )}
      </Button>
    </Box>
  );
}
